import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewInit, OnChanges } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'ch-wysiwyg',
  templateUrl: './wysiwyg.component.html',
  styleUrls: ['./wysiwyg.component.css'],
})
export class WysiwygComponent implements OnInit, AfterViewInit, OnChanges {
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Input() public value: any;
  @ViewChild('chWysiwyg') public ele: ElementRef;
  private $ele;

  constructor() {}

  ngOnInit() {}

  public ngAfterViewInit() {
    this.$ele = jQuery(this.ele.nativeElement);
    this.$ele['summernote']({
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link']],
        ['height', ['height']],
        ['view', ['codeview']],
      ],
    });
    this.$ele['summernote']('code', this.value);
    this.$ele.on('summernote.change', (we, contents, $editable) => {
      this.onChange.emit(contents);
    });
  }

  public ngOnChanges(changes) {
    if (changes.value && changes.value.currentValue && this.$ele) {
      this.$ele['summernote']('code', this.value);
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/wysiwyg/wysiwyg.component.ts